import { useAppSelector } from "@/app/hooks"
import { selectIsAuthenticated } from "@/features/auth/authSlice"
import { PropsWithChildren, lazy } from "react"

const ProtectedRoute = lazy(() => import("@/components/ProtectedRoute"))

const AuthenticatedRoute = ({ children }: PropsWithChildren) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  return (
    <ProtectedRoute hasPermission={isAuthenticated}>{children}</ProtectedRoute>
  )
}

export default AuthenticatedRoute
